import { useContext } from "react";
import { RegContext } from "./contextUtils";

// eslint-disable-next-line import/prefer-default-export
export const useRegContext = () => useContext(RegContext);
